import { BaseApi } from './base.api.js';

export class RegulatorySourceApi extends BaseApi {
    constructor(client) {
        super(client, '/regulatory-source');
    }
}
